export default "__VITE_ASSET__CHjxoXgq__"